import { Component, inject, OnDestroy } from "@angular/core"
import { Subscription } from "rxjs"
import { Router } from "@angular/router";

@Component({
    template: '',
    standalone: false
})
export abstract class BaseComponent implements OnDestroy {

    protected subscriptions = new Subscription()
    protected router: Router = inject(Router);

    /**
     *
     */
    constructor() {

    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }

    setTitle() {
    }
}